import React, { useRef } from 'react';
import styled, { css } from 'styled-components';

import { useWindowEvent } from '../../../hooks/useWindowEvent';

const StyledIFrameWrapper = styled.div`
    border-radius: 4px;
    box-shadow: rgba(0, 0, 0, 0.3) 0px 2px 4px 0px;
    height: 100%;
    position: relative;
    ${({ isIABAd, isTall, numListColumns }) =>
        isIABAd &&
        css`
            display: flex;
            justify-content: center;
            align-items: center;
            height: ${isTall && numListColumns === 1 ? '287px' : '100%'};
        `};
    &:after {
        ${({ isIABAd, isTall }) =>
            isIABAd &&
            isTall &&
            css`
                content: 'Advertisement';
                font-color: #2a2a33;
                font-weight: 400;
                line-height: 10px;
                font-size: 10px;
                position: absolute;
                bottom: 5px;
                margin: auto;
                text-align: center;
            `};
    }
`;

const DetectIFrameClick = ({ children, onClick, ...rest }) => {
    const isMousingOverRef = useRef(false);
    const blurHandler = () => {
        if (isMousingOverRef.current && onClick) {
            onClick();
        }
    };

    useWindowEvent({ eventName: 'blur', callback: blurHandler });

    const onMouseOver = () => {
        isMousingOverRef.current = true;
        if (typeof window !== 'undefined') {
            window.focus();
        }
    };

    const onMouseOut = () => {
        isMousingOverRef.current = false;
    };

    return (
        <StyledIFrameWrapper
            {...rest}
            onMouseOver={onMouseOver}
            onFocus={() => {}}
            onMouseOut={onMouseOut}
            onBlur={() => {}}
        >
            {children}
        </StyledIFrameWrapper>
    );
};

export default DetectIFrameClick;
